// extracted by mini-css-extract-plugin
module.exports = {"calTitleCustom":"AcquisitionTax_calTitleCustom__1Uy0x"};